import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-epic.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.epic',
    description: 'Chart view of change impacts by epic',
    name: 'Change Impacts by Epic',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
